import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { Col } from 'react-bootstrap'
import moment from 'moment'

import SVGCalendar from '../../atoms/SVGCalendar'

class Dates extends PureComponent {
  render () {
    const datesHide = classNames({
      'col-xs-2 pl-0 pr-0': true,
      'hidden-xs': this.props.reducedInfo
    })
    const defaultMenu = classNames({
      'hidden-xs': this.props.reducedInfo
    })
    const ulClassName = `list-unstyled svg col-xs-${this.props.hideBasketSVGs ? '6' : '5'} pl-0 mb-0`

    if (!this.props.hasFixedSummary) {
      return (
        <div>
          {!this.props.hideBasketSVGs &&
            <div className={datesHide}>
              <SVGCalendar
                height='30'
                width='30'
                viewBox='0 0 58 58'
              />
            </div>
          }

          {/* Hotel date on mobile version */}
          {!this.props.showPriceOnMobile && this.props.reducedInfo && [this.props.checkInDate, this.props.checkOutDate].map((date, index) => {
            return (
              <Col className='mt-0 visible-xs-block pb-0' xs={5} key={`date${index}`}>
                <div className='media-body media-middle text-right'>
                  <div className='large-lg'>
                    {date.format('ddd')}
                  </div>
                  <span className='small'>
                    {date.format('MMM')}
                  </span>
                </div>
                <div className='media-right media-middle display-4'>
                  {date.format('D')}
                </div>
              </Col>
            )
          })}

          <div className={defaultMenu}>
            <ul className={ulClassName}>
              <li><FormattedMessage id='common.checkin' tagName='strong' /></li>
              <li>{this.props.checkInDate.format('ddd D MMM YY')}</li>
              <li className='text-muted tiny'>from {this.props.checkInTime}</li>
            </ul>
            <ul className={ulClassName}>
              <li><FormattedMessage id='common.checkout' tagName='strong' /></li>
              <li>{this.props.checkOutDate.format('ddd D MMM YY')}</li>
              <li className='clearfix text-muted tiny'>by {this.props.checkOutTime}</li>
            </ul>
          </div>
        </div>
      )
    }

    return (
      <React.Fragment>
        <li className={this.props.reducedInfo ? 'hidden-xs' : ''}>
          <div className='media'>
            <div className='media-left'>
              {!this.props.hideBasketSVGs &&
                <SVGCalendar
                  height='30'
                  width='30'
                  viewBox='0 0 58 58'
                />
              }
            </div>
            <div className='media-body'>
              <div className='row'>
                <div className='col-xs-6'>
                  <div className='media-heading'><FormattedMessage id='common.checkin' /></div>
                  <div className='text-muted tiny'>{this.props.checkInDate.format('ddd D MMM YY')}</div>
                  <div className='text-muted tiny'>from {this.props.checkInTime}</div>
                </div>
                <div className='col-xs-6'>
                  <div className='media-heading'><FormattedMessage id='common.checkout' /></div>
                  <div className='text-muted tiny'>{this.props.checkOutDate.format('ddd D MMM YY')}</div>
                  <div className='text-muted tiny'>by {this.props.checkOutTime}</div>
                </div>
              </div>
            </div>
          </div>
          <hr className={this.props.reducedInfo ? 'hidden-xs' : ''} />
        </li>
        {/* Hotel date on mobile version */}
        {!this.props.showPriceOnMobile &&
          <div className='clearfix visible-xs-block mb-0'>
            {this.props.reducedInfo && [this.props.checkInDate, this.props.checkOutDate].map((date, index) => {
              return (
                <Col className='mt-0 pb-0' xs={5} key={`date${index}`}>
                  <div className='media-body media-middle text-right'>
                    <div className='large-lg'>
                      {date.format('ddd')}
                    </div>
                    <span className='small'>
                      {date.format('MMM')}
                    </span>
                  </div>
                  <div className='media-right media-middle display-4'>
                    {date.format('D')}
                  </div>
                </Col>
              )
            })}
          </div>
        }
      </React.Fragment>
    )
  }
}

Dates.propTypes = {
  checkInDate: PropTypes.instanceOf(moment).isRequired,
  checkInTime: PropTypes.string.isRequired,
  checkOutDate: PropTypes.instanceOf(moment).isRequired,
  checkOutTime: PropTypes.string.isRequired,
  hasFixedSummary: PropTypes.bool.isRequired,
  hideBasketSVGs: PropTypes.bool
}

export default Dates
